import { render, staticRenderFns } from "./IncRnaQueryRnaInfomation.vue?vue&type=template&id=1891cfae&scoped=true"
import script from "./IncRnaQueryRnaInfomation.vue?vue&type=script&lang=js"
export * from "./IncRnaQueryRnaInfomation.vue?vue&type=script&lang=js"
import style0 from "./IncRnaQueryRnaInfomation.vue?vue&type=style&index=0&id=1891cfae&prod&scoped=true&lang=css"
import style1 from "./IncRnaQueryRnaInfomation.vue?vue&type=style&index=1&id=1891cfae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891cfae",
  null
  
)

export default component.exports